import { Component, OnInit } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { BaseSignUpComponent } from '../base-signup-component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '@auth0/auth0-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { Auth0AuthenticationService } from 'src/app/core/auth0-authentication.service';
import { GolfTechType } from 'src/app/shared/models/golftech-type.enum';
import { SnackbarNotificationComponent } from 'src/app/shared/ui/snackbar-notification/snackbar-notification/snackbar-notification.component';

@Component({
    selector: 'sign-up-outing',
    standalone: true,
    templateUrl: './sign-up-outing.component.html',
    styleUrl: './sign-up-outing.component.scss',
    imports: [SharedModule],
})
export class SignUpOutingComponent extends BaseSignUpComponent implements OnInit {
    constructor(fb: FormBuilder,
        private auth: AuthService,
        private authService: Auth0AuthenticationService,
        private snackBar: MatSnackBar,
    ) {
        super(fb);
    }

    ngOnInit(): void {
        this.billingForm = this.fb.group({
            address: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required],
            zip: ['', [Validators.required, Validators.min(10000), Validators.max(99999)]],
            plan: ['', Validators.required],
        });
        // Fetch plans for outings
        this.stripeService.getProducts({ platform: "outing" }).subscribe({
            next: (plans: any) => {
                this.plans = plans.data.filter((plan: any) => plan.metadata.signup_displayable === "true");
                this.filteredPlans = this.plans;
            },
            error: (err: any) => {
                console.log(err);
            }
        });
    }

    submit(): void {
        if (this.accountForm.invalid || this.billingForm.invalid) return;
        this.isLoading = true;
        const userData = this.accountForm.value;
        const billingData = this.billingForm.value;

        userData.metadata = {
            firstName: userData.given_name,
            lastName: userData.family_name,
            golfTechType: GolfTechType.Organizer,
        }

        this.authService.signup(userData).subscribe({
            next: (auth0Response: any) => {
                this.onSignUpSuccessCreatePaymentMethod(auth0Response);
            },
            error: (err: any) => {
                console.log(err);
                this.isLoading = false;
                let errorMessage;
                if (err.error.code === "invalid_password") {
                    errorMessage = err.error.policy;
                }

                if (err.error.code === "invalid_signup") {
                    errorMessage = "The user already exists.";
                }

                errorMessage = errorMessage.replaceAll("\n", "<br />");

                let data = {
                    text: errorMessage,
                    useInnerHtml: true
                }

                this.snackBar.openFromComponent(SnackbarNotificationComponent, {
                    duration: undefined,
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    data: data
                });
            }
        });
    }

    onSignUpSuccessCreatePaymentMethod(auth0Response: any) {
        this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement.element,
            billing_details: {
                name: `${this.accountForm.value.given_name} ${this.accountForm.value.family_name}`,
                email: this.accountForm.value.email,
                address: {
                    line1: this.billingForm.value.address,
                    city: this.billingForm.value.city,
                    state: this.billingForm.value.state,
                    postal_code: this.billingForm.value.zip,
                    country: 'US'
                }
            }
        }).subscribe({
            next: (res: any) => {
                this.onCreatePaymentMethodSuccess(auth0Response, res);
            },
            error: (err: any) => {
                console.log(err);
                this.isLoading = false;
            }
        });
    }

    onCreatePaymentMethodSuccess(auth0Response: any, res: any) {
        let dto = {
            auth0Id: `auth0|${auth0Response._id}`,
            firstName: this.accountForm.value.given_name,
            lastName: this.accountForm.value.family_name,
            golfTechType: GolfTechType.Organizer.toString(),
            email: this.accountForm.value.email,
            stripeProductId: this.billingForm.value.plan,
            paymentMethodId: res.paymentMethod.id,
        }
        
        this.identityUserService.createIdentityUser(dto).subscribe({
            next: (res: any) => {
                console.log(res);
                this.isLoading = false;
                this.snackBar.openFromComponent(SnackbarNotificationComponent, {
                    duration: 5000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    data: { text: "User created successfully, you will now be redirected to the login page in 5 seconds" }
                });
                setTimeout(() => {
                    this.auth.loginWithRedirect();
                }, 5000);
            },
            error: (err: any) => {
                console.log(err);
                this.isLoading = false;
                this.snackBar.openFromComponent(SnackbarNotificationComponent, {
                    duration: 10000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    data: { text: "There was an error creating the user, please try again or contact support." }
                });
            }
        });
    }
}
